import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { company } from "@data/company";
import { useCanonical } from "@hooks/useCanonical";
import styles from "./Layout.module.css";

const IconWhatsapp = () => (
  <svg viewBox="0 0 24 24" width={26} height={26} fill="currentColor" aria-hidden>
    <path d="M17.5 14.4c-.3-.2-1.8-.9-2.1-1s-.5-.2-.7.2c-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.5-.6.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4s-1.1 1.1-1.1 2.7c0 1.6 1.1 3.1 1.3 3.3.2.2 2.3 3.5 5.5 4.9.8.3 1.4.5 1.8.7.8.2 1.5.2 2 .1.6-.1 1.8-.7 2-1.5.2-.7.2-1.4.2-1.5-.1-.1-.3-.2-.6-.4zm-5.4 7.4h-.1c-1.8 0-3.5-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4c-1-1.6-1.5-3.5-1.5-5.4 0-5.6 4.5-10 10-10 2.7 0 5.2 1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1.1 5.4-4.3 9.9-9.9 9.9zm8.5-18.5C18.6 1.2 15.4 0 12.1 0 5.5 0 .1 5.4.1 12c0 2.1.5 4.1 1.6 5.9L0 24l6.3-1.6c1.7.9 3.6 1.4 5.6 1.4h.1c6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.5z" />
  </svg>
);

export function Layout() {
  const location = useLocation();
  const footerRef = useRef<HTMLElement | null>(null);
  const [fabHidden, setFabHidden] = useState(false);

  useCanonical();

  useEffect(() => {
    if (location.hash) {
      const target = document.getElementById(location.hash.replace("#", ""));
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const footer = document.querySelector("footer");
    if (!footer) return;
    footerRef.current = footer as HTMLElement;
    const observer = new IntersectionObserver(
      ([entry]) => setFabHidden(entry.isIntersecting),
      { rootMargin: "0px 0px -80px 0px", threshold: 0 },
    );
    observer.observe(footer);
    return () => observer.disconnect();
  }, [location.pathname]);

  return (
    <>
      <a href="#main" className="skipLink">
        Saltar al contenido
      </a>
      <Header />
      <main id="main" className={styles.main} tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <a
        className={`${styles.whatsappFab} ${fabHidden ? styles.whatsappFabHidden : ""}`}
        href={`https://wa.me/${company.whatsapp}?text=${encodeURIComponent(
          "Hola, quiero una cotización",
        )}`}
        target="_blank"
        rel="noopener"
        aria-label="Contactar por WhatsApp"
      >
        <IconWhatsapp />
      </a>
    </>
  );
}
